import { render, staticRenderFns } from "./DialogDetails.vue?vue&type=template&id=8c9dca68&scoped=true&"
import script from "./DialogDetails.vue?vue&type=script&lang=js&"
export * from "./DialogDetails.vue?vue&type=script&lang=js&"
import style0 from "./DialogDetails.vue?vue&type=style&index=0&id=8c9dca68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9dca68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
